import React, { useEffect, useState } from 'react';

import * as S from './styled';

export const ScrollProgressBar: React.FC = () => {
  const [width, setWidth] = useState<number>(100);

  const handleOnScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
    if (scrollTop === 0) return setWidth(100);

    const windowHeight = scrollHeight - clientHeight;
    const currentPercent = 100 - (scrollTop / windowHeight) * 100;
    if (currentPercent < 0.1) {
      setWidth(0);
    } else if (currentPercent > 99.9) {
      setWidth(100);
    } else {
      setWidth(currentPercent);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleOnScroll);

    return () => {
      window.removeEventListener('scroll', handleOnScroll);
    };
  }, []);

  return (
    <S.ScrollProgressBarContainer>
      <S.ProgressLeftBar style={{ width: `${width}%` }} />
    </S.ScrollProgressBarContainer>
  );
};
